import { databaseRef } from "../Utilities/firebase";

/* ------------- ACTIONS ------------- */
export const REMOVE_INV_ITEM = "REMOVE_INV_ITEM";
export const ADD_INV_TO_SHOP = "ADD_INV_TO_SHOP";
export const EDIT_INV_ITEM_SLIDER = "EDIT_INV_ITEM_SLIDER";
export const EDIT_INV_ITEM = "EDIT_INV_ITEM";
export const SET_EDIT_ITEM_STATE = "SET_EDIT_ITEM_STATE";
export const SET_SELECTED_ITEM = "SET_SELECTED_ITEM";
export const ADD_CUSTOM_TO_INV = "ADD_CUSTOM_TO_INV";

/* ------------- ACTION CREATORS ------------- */
export function addCustomItemToInventory(
  user,
  name,
  comment,
  quantity,
  fetchEAN,
  fullname,
  size,
  unit_id,
  dep_id,
  dep_name,
  cat_id,
  cat_name,
  subcat_id,
  subcat_name,
  image,
  carbon_fp,
  water_fp,
  nutrients,
  average_price
) {
  // If no EAN is supplied, randomizes a new one
  var EANcode = "";
  if (fetchEAN !== "") {
    EANcode = fetchEAN;
  } else {
    EANcode = Math.floor(Math.random() * 10000000) + 1000000000;
  }

  //Checks if there are previous instances of that item
  var existingQty = 0;
  databaseRef
    .ref("users/" + user + "/inventory/" + EANcode)
    .child("quantity")
    .once("value", function (snapshot) {
      if (snapshot.val() !== undefined && snapshot.val() !== null) {
        console.log(
          "existingQty: ",
          snapshot.val(),
          " new Quantity: ",
          snapshot.val() + quantity
        );
        existingQty = snapshot.val();
      }
    });

  // If no image is supplied, sets image to blank string
  if (image === null) {
    image = "";
  }

  let existingDates = [];
  // If there were an instance of the item, checks and fetches the associated dates
  if (existingQty > 0) {
    databaseRef
      .ref("users/" + user + "/inventory/" + EANcode)
      .child("dates")
      .once("value", function (snapshot) {
        if (snapshot.val() !== null) {
          existingDates = snapshot.val();
        }
      });
  }

  var datesToAdd = 1;
  // Makes sure the number of dates associated with the item corresponds to the qty
  if (existingDates.length > 0) {
    datesToAdd = parseInt(existingQty + quantity - existingDates.length);
  }

  // Adds the amount of dates needed to match the quantity
  var date = new Date().toISOString();
  for (var i = 0; i < datesToAdd; i++) {
    existingDates.push(date);
  }

  var item = {
    EANcode: EANcode,
    fullname: fullname,
    size: size,
    unit_id: unit_id,
    name: name,
    dates: existingDates,
    comment: comment,
    quantity: parseInt(existingQty + quantity),
    amount: 100,
    dep_id: dep_id,
    dep_name: dep_name,
    cat_id: cat_id,
    cat_name: cat_name,
    subcat_id: subcat_id,
    subcat_name: subcat_name,
    image: image,
    carbon_fp: carbon_fp,
    water_fp: water_fp,
    nutrients: nutrients,
    average_price: average_price,
  };

  databaseRef
    .ref("users/" + user + "/inventory")
    .child(EANcode)
    .set(item);

  return { type: ADD_CUSTOM_TO_INV };
}

export function removeInventoryItem(user, item, removeAll) {
  const EANcode = item.EANcode;

  var numberTossed = 1;
  var decQuant = 0;
  var trashQuant = 0;

  // get current quantity from inventory
  databaseRef
    .ref("users/" + user + "/inventory/" + EANcode)
    .child("quantity")
    .once("value", function (snapshot) {
      let curVal = snapshot.val();
      decQuant = curVal - 1;
    });

  // get current quantity from trash
  databaseRef
    .ref("users/" + user + "/trash/" + EANcode)
    .child("quantity")
    .once("value", function (snapshot) {
      trashQuant = snapshot.val();
    });

  // get current dates from inventory
  let invDates = [];
  let oldestItem = {};
  databaseRef
    .ref("users/" + user + "/inventory/" + EANcode)
    .child("dates")
    .once("value", function (snapshot) {
      invDates = snapshot.val();
      oldestItem = invDates.shift();
    });

  // get previous "added"-dates from trash
  let trashDates = [];
  databaseRef
    .ref("users/" + user + "/trash/" + EANcode)
    .child("dates")
    .once("value", function (snapshot) {
      if (snapshot.val() !== null) {
        if (typeof snapshot.val() === "string") {
          trashDates.push(snapshot.val());
        } else {
          snapshot.val().forEach((item) => {
            trashDates.push(item);
          });
        }
      }
    });

  // get previous deletion dates from trash
  let trashDeletionDates = [];
  databaseRef
    .ref("users/" + user + "/trash/" + EANcode)
    .child("deletionDates")
    .once("value", function (snapshot) {
      if (snapshot.val() !== null) {
        if (typeof snapshot.val() === "string") {
          trashDeletionDates.push(snapshot.val());
        } else {
          snapshot.val().forEach((item) => {
            trashDeletionDates.push(item);
          });
        }
      }
    });

  var date = new Date().toISOString();

  trashDeletionDates.push(date);
  trashDates.push(oldestItem);

  if (removeAll) {
    decQuant = 0;
    numberTossed = item.quantity;
  }

  //remove item
  if (decQuant === 0) {
    databaseRef
      .ref("users/" + user + "/inventory")
      .child(EANcode)
      .remove();
  } else {
    let newItem = { ...item, quantity: decQuant, dates: invDates };
    databaseRef
      .ref("users/" + user + "/inventory")
      .child(EANcode)
      .set(newItem);
  }

  // add to trash
  if (trashQuant) {
    databaseRef
      .ref("users/" + user + "/trash")
      .child(EANcode)
      .set({
        ...item,
        dates: trashDates,
        deletionDates: trashDeletionDates,
        quantity: trashQuant + numberTossed,
      });
  } else {
    databaseRef
      .ref("users/" + user + "/trash")
      .child(EANcode)
      .set({
        ...item,
        dates: trashDates,
        deletionDates: trashDeletionDates,
        quantity: numberTossed,
      });
  }

  return { type: REMOVE_INV_ITEM };
}

export function addInvToShopping(user, item) {
  var carbon_fp = "";
  var water_fp = "";

  if (item.carbon_fp !== undefined) {
    carbon_fp = item.carbon_fp;
  }

  if (item.water_fp !== undefined) {
    water_fp = item.water_fp;
  }

  // Get quantity from shopping
  let quantity = 1;
  databaseRef
    .ref("users/" + user + "/shopping/" + item.EANcode)
    .child("quantity")
    .once("value", function (snapshot) {
      let currentQuantity = snapshot.val();
      quantity = currentQuantity + quantity;
    });

  var date = new Date().toISOString();

  var updatedItem = {
    EANcode: item.EANcode,
    fullname: item.fullname,
    size: item.size,
    unit_id: item.unit_id,
    name: item.name,
    dates: [date],
    comment: item.comment,
    quantity: quantity,
    amount: 100,
    dep_id: item.dep_id,
    dep_name: item.dep_name,
    cat_id: item.cat_id,
    cat_name: item.cat_name,
    subcat_id: item.subcat_id,
    subcat_name: item.subcat_name,
    image: item.image,
    carbon_fp: carbon_fp,
    water_fp: water_fp,
  };

  databaseRef
    .ref("users/" + user + "/shopping")
    .child(item.EANcode)
    .set(updatedItem);

  return { type: ADD_INV_TO_SHOP };
}

export function editInventoryItemSlider(user, item, amount) {
  databaseRef
    .ref("users/" + user + "/inventory")
    .child(item.EANcode)
    .child("amount")
    .set(amount);

  return { type: EDIT_INV_ITEM_SLIDER };
}

export function editInventoryItem(user, item, newItem) {
  var dates = item.dates;

  if (newItem.quantity > item.quantity) {
    var date = new Date().toISOString();
    for (var i1 = 0; i1 < newItem.quantity - item.quantity; i1++) {
      dates.push(date);
    }
  } else if (newItem.quantity < item.quantity) {
    for (var i2 = 0; i2 < item.quantity - newItem.quantity; i2++) {
      dates.shift();
    }
  }

  var updatedItem = {
    ...newItem,
    EANcode: item.EANcode,
    name: newItem.name,
    fullname: item.fullname,
    comment: newItem.comment,
    quantity: parseInt(newItem.quantity),
    amount: parseInt(item.amount),
    dates: dates,
  };

  databaseRef
    .ref("users/" + user + "/inventory")
    .child(item.EANcode)
    .update(updatedItem);

  return { type: EDIT_INV_ITEM };
}

export const setEditItemState = (state) => ({
  type: SET_EDIT_ITEM_STATE,
  payload: state,
});

export const setSelectedItem = (item) => ({
  type: SET_SELECTED_ITEM,
  payload: item,
});
